const CATEGORIES = require('./categories');
const TYPES = require('./types');
const EVENTS = require('./events');
const MESSAGES = require('./message');
module.exports = {
    CATEGORIES,
    TYPES,
    EVENTS,
    MESSAGES
};